import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useAdjacentRounds } from '../../../../../api/useAdjacentRounds/useAdjacentRounds';
import { PredictionCard } from './PredictionCard/PredictionCard';
import { PredictionCardSkeleton } from './PredictionCard/PredictionCardSkeleton';

const slideClassName = `
    select-none
    aspect-[3/4]
    max-w-full
    w-[342px] max-xl-msq:w-[330px] max-md-msq:w-[364px] max-xs-msq:w-full
    px-2 max-md-msq:px-1
    first:pl-0 last:pr-0
    min-h-[390px]
`;

export const PredictionCards = () => {
  const { data: rounds, isLoading } = useAdjacentRounds();

  return (
    <Swiper
      className="line-swiper-pagination max-sm-msq:w-full -mx-4 max-md:px-4 md:-mx-2"
      data-qa="prediction_card"
      modules={[Pagination]}
      pagination={{
        enabled: true,
        clickable: true,
      }}
      watchOverflow={true}
      slidesPerView="auto"
    >
      {rounds?.length && !isLoading
        ? rounds.map((round) => {
            return (
              round && (
                <SwiperSlide key={round.id} className={slideClassName}>
                  <PredictionCard round={round} />
                </SwiperSlide>
              )
            );
          })
        : [1, 2, 3].map((id) => {
            return (
              <SwiperSlide key={id} className={slideClassName}>
                <PredictionCardSkeleton />
              </SwiperSlide>
            );
          })}
    </Swiper>
  );
};
